module.exports = [{"name":"sb2727-payment-components","version":1}]